import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '../axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { MandatesResponse } from '@utils/types/mandates/mandates.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export const useGetMandates = () => {
  const { t } = useTranslation();
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sort = (searchParams.sort as string | undefined) || undefined;
  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;
  const q = (searchParams.q as string | undefined) || undefined;

  const fetchMandates = async () => {
    const { mandates } = GET_URL_NEW({ offset, limit, q, sort, direction });
    const { data } = await Axios.get<MandatesResponse>(mandates);
    return data;
  };

  return useQuery<MandatesResponse, AxiosError<BaseError>>(
    ['mandates', offset, limit, q, sort, direction],
    fetchMandates,
    {
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      onError: error => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const d = error.response?.data as any;
        const msg =
          d?.error_description ||
          d?.detail ||
          d?.error ||
          d?.message ||
          t('an-error-has-occurred');
        toast.error(String(msg));
      }
    }
  );
};
